<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>未付费与付费体力占比</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          size="mini"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery()">查询</el-button>
      </el-form-item>
    </el-form>

    <el-card>
      <div slot="header" class="clearfix">
        <span>统计</span>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          align="center"
          label=""
          prop="type"
        />
        <el-table-column
          prop="grand"
          align="center"
          label="总发放"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="not_pay_grand"
          align="center"
          label="未付费发放"
          :formatter="numFormatter"
        />
        <el-table-column
          prop="pay_grand"
          align="center"
          label="付费发放"
          :formatter="numFormatter"
        />
      </el-table>
    </el-card>

    <el-card>
      <el-row :gutter="24">
        <spinRateChart ref="notPay" />
        <spinRateChart ref="pay" />
      </el-row>
    </el-card>

    <UserSpinRate />
  </el-card>
</template>

<script>

import { getCacheQuery, getLastDates, scientificFormat, setCacheQuery } from '@/utils'
import spinRateChart from '@/views/config/spins-consume/compents/spin-rate-chart.vue'
import UserSpinRate from '@/views/config/spins-consume/compents/user-spin-rate.vue'
import { getSpinsConsumeStatDay } from '@/api/statistics/user_remain'
export default {
  name: 'SpinsRate',
  components: { spinRateChart, UserSpinRate },
  data() {
    return {
      tableData: [],
      loading: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        lang: '+',
        type: 15,
        id: 2
      }
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(1)
    this.queryParams.endDate = getLastDates(1)
  },
  mounted() {
    this.getTables(undefined)
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }
      this.queryParams.endDate = this.queryParams.startDate
      this.getTables({})
    },
    async getTables(event) {
      this.loading = true
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      let totalGrant = 0
      // let logCount = 0
      this.tableData = []
      await getSpinsConsumeStatDay(this.queryParams).then(res => {
        this.loading = false
        setCacheQuery(this.$options.name, this.queryParams)
        totalGrant = res.data.data.grant_spin
        // logCount = res.data.log_count
      })
      const notPaySpinsNum = await this.$refs.notPay.refresh(1, this.queryParams)
      const paySpinsNum = await this.$refs.pay.refresh(2, this.queryParams)
      this.tableData.push({
        type: '总数',
        grand: totalGrant,
        not_pay_grand: notPaySpinsNum,
        pay_grand: paySpinsNum
      },
      { type: '占比',
        grand: 0,
        not_pay_grand: (notPaySpinsNum / totalGrant * 100).toFixed(2),
        pay_grand: (paySpinsNum / totalGrant * 100).toFixed(2)
      }
      // { type: '人均发放',
      //   grand: 0,
      //   not_pay_grand: (notPaySpinsNum / logCount).toFixed(2),
      //   pay_grand: (paySpinsNum / logCount).toFixed(2)
      // }
      )
    },
    numFormatter(col, row, val) {
      return scientificFormat(val)
    }
  }
}
</script>

<style scoped>

</style>
